export default function QuelMoteur() {
  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <h2 className="text-2xl md:text-3xl font-bold text-brand-blue mb-6">
          Quel moteur choisir en remplacement
        </h2>
        <p className="text-brand-text leading-relaxed mb-5">
          Le choix du moteur de remplacement dépend de la configuration exacte de votre volet Bubendorff. Si vous souhaitez conserver une commande radio Bubendorff, nous installons un moteur d&apos;origine ou un moteur compatible avec le protocole radio propriétaire. Cette solution garantit que vos télécommandes existantes continuent de fonctionner sans avoir à changer l&apos;ensemble des émetteurs de la maison. Pour les installations plus anciennes, il est parfois préférable de migrer vers un moteur filaire couplé à un module radio universel, ce qui offre plus de flexibilité pour les futures évolutions.
        </p>
        <p className="text-brand-text leading-relaxed mb-8">
          Les modèles solaires imposent de choisir un moteur compatible avec l&apos;alimentation par batteries. Nous proposons des moteurs Bubendorff d&apos;origine pour les clients qui veulent préserver l&apos;authenticité de leur installation, mais aussi des alternatives de qualité équivalente lorsque la pièce d&apos;origine n&apos;est plus fabriquée. Le diamètre du moteur, sa puissance en newton-mètres et son couple de démarrage sont calculés en fonction du poids du tablier et de la surface du volet. Nos techniciens mesurent ces paramètres sur place pour vous recommander le moteur parfaitement adapté, sans surdimensionnement inutile.
        </p>

        <h3 className="text-xl font-semibold text-brand-blue mb-4">
          Critères de sélection du moteur de remplacement
        </h3>
        <ul className="space-y-3">
          {[
            "Compatibilité radio Bubendorff ou migration vers module universel",
            "Alimentation solaire, filaire 230 V ou batterie rechargeable selon l&apos;installation",
            "Puissance adaptée au poids et à la surface du tablier existant",
            "Diamètre du moteur correspondant au logement intégré du tablier",
            "Vitesse de manœuvre compatible avec les glissières et l&apos;enrouleur",
            "Garantie constructeur et disponibilité des pièces détachées sur le long terme",
          ].map((item) => (
            <li key={item} className="flex items-start gap-3">
              <span className="w-5 h-5 flex items-center justify-center text-brand-cyan mt-0.5 flex-shrink-0">
                <i className="ri-checkbox-circle-line text-lg"></i>
              </span>
              <span className="text-brand-text text-sm md:text-base">{item}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}